/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const PimProductV1LifestyleProductEnum = {
    True: 'true',
    TrueWithExceptions: 'true_with_exceptions',
    False: 'false'
};
export const PimProductV1NowProductGroupEnum = {
    None: 'none',
    SamedayNextday: 'sameday_nextday',
    Nextday: 'nextday'
};
export const PimProductV1StockStatusEnum = {
    Available: 'available',
    OutOfSale: 'out_of_sale',
    OutOfStock: 'out_of_stock',
    NotInCatalog: 'not_in_catalog',
    Free: 'free',
    Service: 'service',
    Variant: 'variant'
};
export const PimProductV1TypeEnum = {
    Article: 'article',
    Service: 'service',
    Set: 'set'
};
